import { render } from "./MainIndex.vue?vue&type=template&id=28f95bfe&scoped=true"
import script from "./MainIndex.vue?vue&type=script&lang=js"
export * from "./MainIndex.vue?vue&type=script&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=28f95bfe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f95bfe"]])

export default __exports__